import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { dashboardQueryOptions } from './dashboard-query-options';

interface Get90PercentFullClassesResponse {
  totalCount: number;
}

interface Get90PercentFullClassesParams {
  sessionId: string;
}

export const get90PercentFullClassesAPI = async (
  params: Get90PercentFullClassesParams,
) => {
  const response = await baseAPI.get<Get90PercentFullClassesResponse>(
    '/dashboard/class-performance/near-capacity/count',
    {
      params: {
        sessionId: params.sessionId,
      },
    },
  );
  return response.data;
};

export const useGet90PercentFullClasses = (
  params: Get90PercentFullClassesParams,
) => {
  return useQuery({
    ...dashboardQueryOptions,
    queryKey: [KEYS.NINETY_PERCENT_FULL_CLASSES, params.sessionId],
    queryFn: () => get90PercentFullClassesAPI(params),
    enabled: !!params.sessionId,
  });
};
